const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
 * @function evaluate - evaluates a conditional value `test`,
 * and if it is truthy, it returns the value property.
 */

const evaluate = async (format, content, parentContentPath, transientContext, nativeFunctions) => {
  const test = format.test,
    onTrue = format.onTrue,
    onFalse = format.onFalse;
  const testResult = await evaluateSource(test, content, parentContentPath, transientContext, nativeFunctions);
  if (testResult === undefined) {
    return undefined;
  }
  if (onTrue !== undefined && testResult === true) {
    return evaluateSource(onTrue, content, parentContentPath, transientContext, nativeFunctions);
  }
  if (onFalse !== undefined && testResult === false) {
    return evaluateSource(onFalse, content, parentContentPath, transientContext, nativeFunctions);
  }
  return undefined;
};
module.exports = {
  evaluate
};